import { Box, Text, VStack } from "@chakra-ui/react"

export default function CustomerOrders() {
  return (
    <Box p={8} textAlign="center">
      <VStack gap={2}>
        <Text fontSize="lg" fontWeight="semibold">
          Customer Orders
        </Text>
        <Text fontSize="sm" color="fg.muted">
          This view will display customer orders. Implementation pending.
        </Text>
      </VStack>
    </Box>
  )
}

